import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana80Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1462_9855)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M653.463 507.546L645.241 477.4L588.485 481.881L592.966 528.182L642.254 525.195C650.238 525.195 653.221 518.249 653.987 513.059C654.259 511.212 653.954 509.347 653.463 507.546Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M531.735 534.159L592.972 528.185L588.491 481.884L528.748 487.858L531.735 534.159Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M470.497 538.637L531.734 534.156L528.746 487.855L467.51 492.336L470.497 538.637Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M425.694 541.624L470.501 538.637L466.021 469.933L421.213 492.336L425.694 541.624Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M352.51 547.6L425.695 541.626L421.212 492.338L350.243 529.996C348.826 530.748 347.739 532.035 347.392 533.6C345.156 543.668 349.735 547.138 352.51 547.6Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M531.735 432.593L466.018 469.932L467.512 492.336L536.216 486.362L531.735 432.593Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M546.674 423.631L531.738 432.592L536.219 486.362L584.013 481.881L581.026 431.099C576.545 431.099 560.116 426.618 557.129 423.631C554.739 421.241 549.163 422.635 546.674 423.631Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M633.296 431.1L645.244 477.401L584.008 481.881L581.021 431.1C592.969 432.594 607.905 428.113 618.36 423.632C626.724 420.048 631.802 427.117 633.296 431.1Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1462_9855" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1462_9855" transform="matrix(0.00204869 0 0 0.00271602 -4.90885 -1.02286)"/>
    </pattern>
    <image id="image0_1462_9855" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};